export const data = [
	{
		video: 'zwirn.mp4',
		image: 'zwirn-thumb.jpg',
		title: 'Our projects',
		body: '<p>Geometric model LOD 300 of power distribution end elements, structured cabling, EPS, FAS, ESS, lightning rods and ' +
			'area lighting. Cable distribution modeled in real scale, on real routes / deposits – ' +
			'calculations of mutual warming of NN distributions and of canal loads. Real cable endings modeling – ' +
			'waste after device placements. More than 3.5 mil. parameters set for a project. Dimensions report almost identical to reality.</p>' +
			'<a target="_blank" href="https://www.youtube.com/watch?v=SbwoBMDITQs"><div class="flex flex-row items-center">' +
			'<img src="img/public/icons/list_icon_blue.png" class="list-icon"> Watch our webinar' +
			'</div></a>',
	},
	{
		image: '1-lean.jpg',
		title: 'Lean Construction',
		body: '<p>The lean process is a collection of tools for improving the construction processes with minimal costs and maximal value, ' +
			'based on requirements of our customer, while simultaneously helps achieving and upkeeping sustainability goals in all three dimensions of ' +
			'environment, people and gain along complete construction supply chain.</p>\n' +
			'<p>We use tools for modeling, control and communication during construction preparations themselves. ' +
			'We use the Revit Autodesk software tool for model management using the BIM method.</p>',
	},
	{
		image: '2-1-bim.jpg',
		title: 'BIM modeling method <h1 class="text-sm -mt-1">(Building information modeling)</h1>',
		body: '<h1>Why BIM?</h1>\n' +
			'<p>The advantage of using the BIM modeling method is that it solves almost all technical details and collisions, ' +
			'which is impossible via standard 2D methods and specific shortcomings become visible only on site, item filtering ' +
			'- for example for budgets based on suitably filled up paramters, exact budget (error around 7% in comparison to 2D methods) - ' +
			'almost exact information about total investment costs even during construction preparations.</p>',
	},
	{
		image: '2-2-bim.jpg',
		title: 'BIM modeling method <h1 class="text-sm -mt-1">(Building information modeling)</h1>',
		body: '<h1>Is BIM expensive?</h1>\n' +
			'<p>Surcharges regarding BIM are units of magnitude lower than prices of possible changes realized during the construction process. ' +
			'BIM does not, however, replace designers experience.</p>' +
			'<h1>Why Revit Autodesk</h1>\n' +
			'<p>100% compatibility with CAD software, unlimited item parametrization, real 3D geometry of all the elements including cable distributions, ' +
			'*.ifc export compatibility with other calculation software - for example Dialux, suitable for big constructions.</p>',
	},
	{
		image: '3-1-dialux.jpg',
		title: 'Artificial and emergency lighting calculations',
		body: '<p>ifc model export into Dialux calculation software allows to simulate ' +
			'exact lighting intensity on required surfaces with real contour geometries. Dialux allows setting exact surface materials ' +
			'their reflectivity and maintenance factor, which affects actual lighting system design. ' +
			'These aspects must be taken into account as required by the legal meaning of STN.</p>',
	},
	{
		image: '3-2-dialux.jpg',
		title: 'Artificial and emergency lighting calculations',
		body: '<p>ifc model export into Dialux calculation software allows to simulate ' +
			'exact lighting intensity on required surfaces with real contour geometries. Dialux allows setting exact surface materials ' +
			'their reflectivity and maintenance factor, which affects actual lighting system design. ' +
			'These aspects must be taken into account as required by the legal meaning of STN.</p>',
	},
	{
		image: '4-sichr.jpg',
		title: 'Wiring parameter calculations',
		body: '<p>All our solutions are substantiated by computations. An example is a simulation of main wiring distribution in Sichr. ' +
			'Wirings are simulated for voltage drops, warming, current loads and shut-off loop impedance. ' +
			'Subsequently, all the wirings are realistically modeled with possible mutual offsets.</p>',
	},
	{
		image: '5-hsp.jpg',
		title: 'FAVES acoustics simulation',
		body: '<p>Comprehensibility and acoustic pressure are simulated via a calculation software for a correct FAVES system design. ' +
			'This allows for an emergency fire announcement to be understandable at any spot in the building.</p>',
	},
	{
		image: '6-cctv.jpg',
		title: 'CCTV simulation',
		body: '<p>Face or license plate readability is simulated via a calculation software for a correct CCTV system design.</p>',
	},
	{
		image: '7-1-kolizia.jpg',
		title: 'Collision detection, coordination',
		body: '<p>Collision detection is an example benefit of 3D software. Collisions removal during project design saves time and ' +
			'expenses during construction. It also lowers personal requirements on construction management.</p>',
	},
	{
		image: '7-2-kolizia.jpg',
		title: 'Collision detection, coordination',
		body: '<p>Collision detection is an example benefit of 3D software. Collisions removal during project design saves time and ' +
			'expenses during construction. It also lowers personal requirements on construction management.</p>',
	},
	{
		image: '7-3-koordinacia.jpg',
		title: 'Collision detection, coordination',
		body: '<p>Collision detection is an example benefit of 3D software. Collisions removal during project design saves time and ' +
			'expenses during construction. It also lowers personal requirements on construction management.</p>',
	},
	{
		image: '8-last-planner.jpg',
		title: 'Project management / communication tools',
		body: '<p>Significant differences surface during the project design process, especially in project management methods. ' +
			'Lean construction allows us to for example utilize the last planner system - as a tool for issuing and summarizing specific tasks, ' +
			'or a common data environment (CDE) as a shared cloud environment, which can after an agreement among GDs, investor and the design team ' +
			'host periodically updated work in progress models. A great advantage along the possibility for an investor to give comments during the ' +
			'design process is the fact that every profession has an up-to-date information about progress among other professions, which can, ' +
			'with a great designer team, help coordination outright during the technical solution processing.</p>',
	},
	{
		image: '9-01-rozvodna.jpg',
		title: 'Our projects',
		body: '<p>End elements modeling is, in respect to time, comparable with 2D methods. Distributions modeling belongs among ' +
			'the most difficult tasks which impact the project price, so its applicability should be considered. It\'s most useful from a ' +
			'viewpoint of a complex project, spatial orientation, micromanagement, cable list creation, exact investment costs, and during building management.</p>\n' +
			'<p> Lightning rod and grouding - outside spatial orientation, which is a big improvement to the design process of every component, is for example the fact that ' +
			'every designer and construction contractor can make any detail, view or cut.</p>',
	},
	{
		image: '9-02-suteren.jpg',
		title: 'Our projects',
		body: '<p>End elements modeling is, in respect to time, comparable with 2D methods. Distributions modeling belongs among ' +
			'the most difficult tasks which impact the project price, so its applicability should be considered. It\'s most useful from a ' +
			'viewpoint of a complex project, spatial orientation, micromanagement, cable list creation, exact investment costs, and during building management.</p>\n' +
			'<p> Lightning rod and grouding - outside spatial orientation, which is a big improvement to the design process of every component, is for example the fact that ' +
			'every designer and construction contractor can make any detail, view or cut.</p>',
	},
	{
		image: '9-03-kable.jpg',
		title: 'Our projects',
		body: '<p>End elements modeling is, in respect to time, comparable with 2D methods. Distributions modeling belongs among ' +
			'the most difficult tasks which impact the project price, so its applicability should be considered. It\'s most useful from a ' +
			'viewpoint of a complex project, spatial orientation, micromanagement, cable list creation, exact investment costs, and during building management.</p>\n' +
			'<p> Lightning rod and grouding - outside spatial orientation, which is a big improvement to the design process of every component, is for example the fact that ' +
			'every designer and construction contractor can make any detail, view or cut.</p>',
	},
	{
		image: '9-04-kable.jpg',
		title: 'Our projects',
		body: '<p>End elements modeling is, in respect to time, comparable with 2D methods. Distributions modeling belongs among ' +
			'the most difficult tasks which impact the project price, so its applicability should be considered. It\'s most useful from a ' +
			'viewpoint of a complex project, spatial orientation, micromanagement, cable list creation, exact investment costs, and during building management.</p>\n' +
			'<p> Lightning rod and grouding - outside spatial orientation, which is a big improvement to the design process of every component, is for example the fact that ' +
			'every designer and construction contractor can make any detail, view or cut.</p>',
	},
	{
		image: '9-05-koordinak.jpg',
		title: 'Our projects',
		body: '<p>End elements modeling is, in respect to time, comparable with 2D methods. Distributions modeling belongs among ' +
			'the most difficult tasks which impact the project price, so its applicability should be considered. It\'s most useful from a ' +
			'viewpoint of a complex project, spatial orientation, micromanagement, cable list creation, exact investment costs, and during building management.</p>\n' +
			'<p> Lightning rod and grouding - outside spatial orientation, which is a big improvement to the design process of every component, is for example the fact that ' +
			'every designer and construction contractor can make any detail, view or cut.</p>',
	},
	{
		image: '9-06-byt.jpg',
		title: 'Our projects',
		body: '<p>End elements modeling is, in respect to time, comparable with 2D methods. Distributions modeling belongs among ' +
			'the most difficult tasks which impact the project price, so its applicability should be considered. It\'s most useful from a ' +
			'viewpoint of a complex project, spatial orientation, micromanagement, cable list creation, exact investment costs, and during building management.</p>\n' +
			'<p> Lightning rod and grouding - outside spatial orientation, which is a big improvement to the design process of every component, is for example the fact that ' +
			'every designer and construction contractor can make any detail, view or cut.</p>',
	},
	{
		image: '9-07.jpg',
		title: 'Our projects',
		body: '<p>End elements modeling is, in respect to time, comparable with 2D methods. Distributions modeling belongs among ' +
			'the most difficult tasks which impact the project price, so its applicability should be considered. It\'s most useful from a ' +
			'viewpoint of a complex project, spatial orientation, micromanagement, cable list creation, exact investment costs, and during building management.</p>\n' +
			'<p> Lightning rod and grouding - outside spatial orientation, which is a big improvement to the design process of every component, is for example the fact that ' +
			'every designer and construction contractor can make any detail, view or cut.</p>',
	},
	{
		image: '9-08.jpg',
		title: 'Our projects',
		body: '<p>End elements modeling is, in respect to time, comparable with 2D methods. Distributions modeling belongs among ' +
			'the most difficult tasks which impact the project price, so its applicability should be considered. It\'s most useful from a ' +
			'viewpoint of a complex project, spatial orientation, micromanagement, cable list creation, exact investment costs, and during building management.</p>\n' +
			'<p> Lightning rod and grouding - outside spatial orientation, which is a big improvement to the design process of every component, is for example the fact that ' +
			'every designer and construction contractor can make any detail, view or cut.</p>',
	},
	{
		image: '9-09.jpg',
		title: 'Our projects',
		body: '<p>End elements modeling is, in respect to time, comparable with 2D methods. Distributions modeling belongs among ' +
			'the most difficult tasks which impact the project price, so its applicability should be considered. It\'s most useful from a ' +
			'viewpoint of a complex project, spatial orientation, micromanagement, cable list creation, exact investment costs, and during building management.</p>\n' +
			'<p> Lightning rod and grouding - outside spatial orientation, which is a big improvement to the design process of every component, is for example the fact that ' +
			'every designer and construction contractor can make any detail, view or cut.</p>',
	},
	{
		image: '9-10.jpg',
		title: 'Our projects',
		body: '<p>End elements modeling is, in respect to time, comparable with 2D methods. Distributions modeling belongs among ' +
			'the most difficult tasks which impact the project price, so its applicability should be considered. It\'s most useful from a ' +
			'viewpoint of a complex project, spatial orientation, micromanagement, cable list creation, exact investment costs, and during building management.</p>\n' +
			'<p> Lightning rod and grouding - outside spatial orientation, which is a big improvement to the design process of every component, is for example the fact that ' +
			'every designer and construction contractor can make any detail, view or cut.</p>',
	},
	{
		image: '9-11.jpg',
		title: 'Our projects',
		body: '<p>End elements modeling is, in respect to time, comparable with 2D methods. Distributions modeling belongs among ' +
			'the most difficult tasks which impact the project price, so its applicability should be considered. It\'s most useful from a ' +
			'viewpoint of a complex project, spatial orientation, micromanagement, cable list creation, exact investment costs, and during building management.</p>\n' +
			'<p> Lightning rod and grouding - outside spatial orientation, which is a big improvement to the design process of every component, is for example the fact that ' +
			'every designer and construction contractor can make any detail, view or cut.</p>',
	},
];
